/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Card_Image_AltInputs */



/**
* | output |
* | --- |
* | "Card" |
*
* @param {Deck_Card_Image_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_card_image_alt = /** @type {((inputs?: Deck_Card_Image_AltInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Card_Image_AltInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Carte")
	if (locale === "es") return /** @type {LocalizedString} */ ("Carta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Carta")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carta")
	return /** @type {LocalizedString} */ ("Card")
});